export function isFreeTrialLevel(level?: string): boolean {
    return level?.endsWith('-ft') ?? false;
}
